export default {
    UPLOAD_NEW_BLOG: 'UPLOAD_NEW_BLOG',
    LIST_BLOG: 'LIST_BLOG',
    INFO_BLOG: 'INFO_BLOG',
    UPDATE_BLOG: 'UPDATE_BLOG',
    DELETE_BLOG: 'DELETE_BLOG',
}